import React from 'react';
import { observable, toJS } from "mobx";
import ProgramacaoService from "../../../services/ProgramacaoNaviosService";
import moment from "moment";
import {
    formatarDataCustomHTML, situacaoFormatter, appendFieldSpan, appendField,
    appendFieldDadosGerais, formatarMovs, formatNullableValue, movsPopOver
} from '../../../utils/formatar';
import { buscaSemResultado, buscaFiltrarVazio } from '../../../utils/mensagens';
import { sortCaret } from '../../comum/components/Icones';
import LoadingImage from "../../comum/components/LoadingImage";

export default class ProgramacaoNaviosStore {

    @observable programacaoLista;
    @observable itemSelecionado;
    @observable qtdRegistros;
    @observable loading;

    /** Paginação */
    @observable total;
    @observable hasNextPage;

    /** Filtro */
    @observable dataInicial;
    @observable dataFinal;
    @observable seletorPeriodo;
    @observable situacaoBerco;
    @observable filtroSelecionado;
    @observable filtroSelecionadoTemp;

    @observable colunas;
    @observable dadosGerais;
    @observable dadosOperacao;
    @observable dadosMov;

    @observable mostrarFiltro;
    @observable filtrosAvancados;
    @observable situacaoVisivel;
    @observable predefinicaoSelecionada;

    @observable tableMessage;
    @observable movsBox
    @observable movsData
    @observable popX
    @observable popY

    @observable listaTabela
    @observable itemsTabela
    @observable noDataTabela
    @observable atualizaTabela
    @observable hasMoreTabela

    @observable pesquisaViagem

    constructor() {
        this.tableMessage = buscaFiltrarVazio

        this.programacaoLista = [];
        this.qtdRegistros = null;
        this.loading = false;

        {/*  TODO : criar store para paginação */ }
        /** Paginação */
        this.total = null;
        this.hasNextPage = null;

        /** Filtros */
        this.dataInicial = moment().subtract(7, 'day').format("YYYY-MM-DD");
        this.dataFinal = moment().add(30, 'day').format("YYYY-MM-DD");
        this.seletorPeriodo = false;
        this.situacaoBerco = false;
        this.filtrosBerco = process.env.rig ? ["Programado", "Em operação", "Operado", "Atracado", "Em espera"] : ["Em operação", "Operado", "Atracado", "Em espera"];
        this.filtroSelecionado = [];
        this.pesquisaViagem = "";
        this.filtroSelecionadoTemp = [];
        this.filtrosAvancados = [];
        this.dataInicialTemp = false;
        this.dataFinalTemp = false;
        this.situacaoVisivel = [];
        this.predefinicaoSelecionada = 0
        this.mostrarFiltro = false;
        this.movsBox = false
        this.movsData = {}
        this.popX = 0
        this.popY = 0

        this.listaTabela = [];
        this.itemsTabela = [];
        this.noDataTabela = this.tableMessage;
        this.turnTabela = 0;
        this.toShow = 20;
        this.atualizaTabela = false;

        this.todasSituacoes = ["Programado", "Em espera", "Atracado", "Em operação", "Operado", "Fechado", "Cancelado"];
        this.todasColunas = [{
            dataField: 'NavioNome',
            text: 'Navio / Viagem',
            id: "F1",
            sort: true,
            sortCaret: sortCaret,
            formatter: appendFieldSpan,
            formatExtraData: 'Viagem',
            sortCaret: sortCaret,
            filterValue: (cell, row) => cell + ' ' + row.Viagem
        }, {
            dataField: 'Berco',
            text: 'Berço',
            id: "F5",
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Armador',
            id: "F6",
            text: 'Armador',
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'ServicoNome',
            text: 'Serviço',
            id: "F3",
            headerStyle: () => {
                return { maxWidth: "80px" };
            },
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'DeadlineDry',
            text: 'Deadline Dry',
            id: "F2",
            headerStyle: () => {
                return { maxWidth: "140px" };
            },
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'InicioRecebVazio',
            text: 'Início Recebimento (Vazio)',
            id: "F26",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'InicioRecebCheio',
            text: 'Início Recebimento (Cheio)',
            id: "F27",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'Eta',
            text: 'ETA',
            id: "F8",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            formatExtraData: 'Estimativa chegada do navio',
            headerTitle: () => 'Estimativa chegada do navio'
        }, {
            dataField: 'Etb',
            text: 'ETB',
            id: "F9",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            formatExtraData: 'Estimativa atracação do navio',
            headerTitle: () => 'Estimativa atracação do navio'
        }, {
            dataField: 'Etd',
            text: !process.env.rig ? 'ETD' : 'ETS',
            id: "F10",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML,
            formatExtraData: 'Estimativa saída do navio',
            headerTitle: () => 'Estimativa saída do navio'
        }, {
            dataField: 'ChegadaBarra',
            text: 'Chegada na Barra',
            id: "F30",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'PraticoBordoAtraca',
            text: 'Prático a Bordo (Atracação)',
            id: "F28",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'ChegadaReal',
            text: 'Atracação',
            id: "F19",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'InicioReal',
            text: 'Início Real',
            id: "F21",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'FimReal',
            text: 'Fim Real',
            id: "F22",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'PraticoBordoDesatraca',
            text: 'Prático a Bordo (Desatracação)',
            id: "F29",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'PartidaReal',
            text: 'Desatracação',
            id: "F20",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'Tipo',
            text: 'Tipo',
            id: "F12",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'PaisDesc',
            text: 'País',
            id: "F7",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Comprimento',
            text: 'Comprimento',
            id: "F13",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Largura',
            text: 'Largura',
            id: "F14",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Movs',
            text: 'Movs',
            id: "F15",
            sort: true,
            sortCaret: sortCaret,
            formatter: movsPopOver,
            events: { onClick: this.clickPopUpMov }
            //adicionar uma formatação para que quando ele seja clicado apareça o pop up
            //basicamente adicionar ao popup ao elemento movs na célula
        }, {
            dataField: 'LloydsId',
            text: 'Lloyds',
            id: "F16",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'RadioCallSign',
            text: 'Callsign',
            id: "F23",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Rows',
            text: 'N de ROWS',
            id: "F17",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'DePara',
            text: 'De / Para',
            id: "F18",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'EscalaSiscarga',
            text: 'Escala Siscarga',
            id: "F24",
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Liberacao',
            text: 'Liberação RFB',
            id: "F25",
            sort: true,
            sortCaret: sortCaret,
            formatter: formatarDataCustomHTML
        }, {
            dataField: 'Situacao',
            text: 'Situação',
            id: "F4",
            sort: true,
            sortCaret: sortCaret,
            formatter: situacaoFormatter
        }];

        this.colunas = this.todasColunas;

        this.dadosGerais = [
            { titulo: "Armador", field: ["Armador"], id: "F6", hidden: false },
            { titulo: "Berço", field: ["Berco"], id: "F5", hidden: false },
            { titulo: "Callsign", field: ["RadioCallSign"], id: "F23", hidden: false },
            { titulo: "Comprimento", field: ["Comprimento"], id: "F13", hidden: false },
            { titulo: "De / Para", field: ["DePara"], id: "F18", hidden: false },
            { titulo: "Escala Siscarga", field: ["EscalaSiscarga"], id: "F24", hidden: false },
            { titulo: "Largura", field: ["Largura"], id: "F14", hidden: false },
            { titulo: "Lloyds", field: ["LloydsId"], id: "F16", hidden: false },
            { titulo: "Movs", field: ["Movs"], id: "F15", hidden: false, events: { onClick: this.onClickPopUpMovCard }, movs: true },
            { titulo: "N de ROWS", field: ["Rows"], id: "F17", hidden: false },
            { titulo: "País", field: ["PaisDesc"], id: "F7", hidden: false },
            { titulo: "Tipo", field: ["Tipo"], id: "F12", hidden: false }
        ];

        this.dadosOperacao = [
            { titulo: "Cheio", field: ["InicioRecebCheio"], id: "F27", label: "Início Recebimento", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "Vazio", field: ["InicioRecebVazio"], id: "F26", label: "Início Recebimento", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "ETA", field: ["Eta"], id: "F8", label: "Estimativa Chegada", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "ETB", field: ["Etb"], id: "F9", label: "Estimativa Atracação", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "ETD", field: ["Etd"], id: "F10", label: "Estimativa Saída", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "Atracação", field: ["PraticoBordoAtraca"], id: "F28", label: "Prático a Bordo", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "", field: ["ChegadaReal"], id: "F19", label: "Atracação", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "", field: ["InicioReal"], id: "F21", label: "Início Operação", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "", field: ["FimReal"], id: "F22", label: "Fim Operação", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "Desatracação", field: ["PraticoBordoDesatraca"], id: "F29", label: "Prático a Bordo", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "", field: ["PartidaReal"], id: "F20", label: "Desatracação", formatacao: formatarDataCustomHTML, hidden: false },
            { titulo: "", field: ["Liberacao"], id: "F25", label: "Liberação RFB", formatacao: formatarDataCustomHTML, hidden: false },
        ];
        if (!process.env.rig) this.dadosOperacao.splice(5, 0, { titulo: "", field: ["ChegadaBarra"], id: "F30", label: "Chegada na Barra", formatacao: formatarDataCustomHTML, hidden: false });

        this.dadosMov = [
            { titulo: "Carga", field: ["Load"], hidden: false },
            { titulo: "Descarga", field: ["Discharge"], hidden: false },
            { titulo: "Remoção", field: ["Remocao"], hidden: false },
            { titulo: "Carga Geral", field: ["VolumeCg"], hidden: false }
        ];

        /** Serviços de programação de navios */
        this.programacaoService = new ProgramacaoService(!process.env.rig);
        this.timerSearch = null
    }

    async carregaFiltros() {
        if (!this.situacaoBerco) {
            this.filtroSelecionado["dataInicial"] = this.dataInicial;
            this.filtroSelecionado["dataFinal"] = this.dataFinal;
        }

        const filtros = await this.programacaoService.buscarFiltrosVisualizacao();

        if (filtros.data.length === 0) {
            this.filtrosAvancados = ["F1", "F2", "F3", "F4", "F5", "F6", "F8", "F9", "F10", "F15"];
            this.situacaoVisivel = ["Todos"]
        } else {
            filtros.data.map(f => { // TODO apenas para alteração do padrão anterior remover quando for seguro
                let fi = JSON.parse(f.ValorObjeto)
                if (fi.dadosTabela.includes("Navio / Viagem")) {
                    f.ValorObjeto = "{\"valor\":0,\"nome\":\"Padrão\",\"descricao\":\"\",\"dadosTabela\":[\"F1\",\"F2\",\"F3\",\"F4\"],\"situacoes\":[\"Todos\"]}";
                }
            });

            const predefAtivo = filtros.data.map(filtro => {
                return JSON.parse(filtro.ValorObjeto).valor
            });
            this.predefinicaoSelecionada = predefAtivo.indexOf(1);
            //So para garantir, caso não tenha nenhuma predefinição ativa, então me coloque a primeira como ativa
            if (this.predefinicaoSelecionada === -1) {
                this.predefinicaoSelecionada = 0;
            }
            let resultado = JSON.parse(filtros.data[this.predefinicaoSelecionada].ValorObjeto);
            if (this.filtrosAvancados.length === 0) {
                this.filtrosAvancados = resultado.dadosTabela;
            }
            if (this.situacaoVisivel.length === 0) {
                this.situacaoVisivel = this.extrairSituacoesPredefinicoes(resultado);
            }
        }
        this.aplicaFiltro();
    };

    async carregarListaEsperando() {
        try {
            this.loading = true;

            if (!this.situacaoBerco) {
                this.filtroSelecionado["dataInicial"] = this.dataInicial;
                this.filtroSelecionado["dataFinal"] = this.dataFinal;
            }
            const { data } = await this.programacaoService.listar(this.filtroSelecionado);

            if (data) {
                this.programacaoLista = data.Data || [];

                if (this.programacaoLista.length === 0) this.tableMessage = buscaSemResultado

                this.total = data.Total || 0;
                this.hasNextPage = data.HasNextPage || false;

            } else {
                this.tableMessage = buscaSemResultado
            }
            this.setNoDataTabela(this.tableMessage);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.loading = false;
        };
    }

    setFiltroSelecionado(campo, valor) {
        this.pesquisaViagem = valor
        this.filtroSelecionado[campo] = this.pesquisaViagem;
        if (this.timerSearch !== null) clearTimeout(this.timerSearch)
        this.timerSearch = setTimeout(() => this.mudarPeriodo(), 1500);
    }

    carregarLista() {
        { /* TODO: verificar filtro pra listar / remover listarPorData() */ }
        this.loading = true;
        this.seletorPeriodo = false;

        {/* TODO: alterar isso quando os outros filtros ficarem prontos */ }
        if (!this.situacaoBerco) {
            this.filtroSelecionado["dataInicial"] = this.dataInicial;
            this.filtroSelecionado["dataFinal"] = this.dataFinal;
        }

        { /** Workaround: para forçar tabela renderizar novamente */ }
        this.programacaoLista = [];

        const loadingPromises = Promise.all([
            this.programacaoService.buscarFiltrosVisualizacao().then(response => {
                if (response.data.length === 0) {
                    this.filtrosAvancados = ["F1", "F2", "F3", "F4"];
                    this.situacaoVisivel = ["Todos"]

                    this.aplicaFiltro()
                } else {
                    response.data.map(f => {
                        let fi = JSON.parse(f.ValorObjeto)
                        if (fi.dadosTabela.includes("Navio / Viagem")) {
                            f.ValorObjeto = "{\"valor\":0,\"nome\":\"Padrão\",\"descricao\":\"\",\"dadosTabela\":[\"F1\",\"F2\",\"F3\",\"F4\"],\"situacoes\":[\"Todos\"]}";
                        }
                    });
                    const predefAtivo = response.data.map(filtro => {
                        return JSON.parse(filtro.ValorObjeto).valor
                    })
                    this.predefinicaoSelecionada = predefAtivo.indexOf(1)
                    //So para garantir, caso não tenha nenhuma predefinição ativa, então me coloque a primeira como ativa
                    if (this.predefinicaoSelecionada === -1) {
                        this.predefinicaoSelecionada = 0
                    }
                    let resultado = JSON.parse(response.data[this.predefinicaoSelecionada].ValorObjeto);
                    if (this.filtrosAvancados.length === 0) {
                        console.log(resultado.dadosTabela)
                        this.filtrosAvancados = this.programacaoService.todosDadosTabela.filter((item) => {
                            console.log(item)
                            return resultado.dadosTabela.indexOf(item.id) > -1;
                        });
                    }
                    if (this.situacaoVisivel.length === 0) {
                        this.situacaoVisivel = this.extrairSituacoesPredefinicoes(resultado);
                    }

                    this.aplicaFiltro();
                }

                this.programacaoService.listar(this.filtroSelecionado).then(response => {
                    this.programacaoLista = response.data.Data;
                    if (this.programacaoLista.length === 0) {
                        this.tableMessage = buscaSemResultado
                    } else {
                        this.tableMessage = buscaFiltrarVazio
                    }
                    this.total = response.data.Total;
                    this.hasNextPage = response.data.HasNextPage;
                    this.setNoDataTabela(this.tableMessage);
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    console.log(error);
                });

            }).catch(erro => { this.loading = false; console.log(erro) })
        ]);
        loadingPromises.then(
            () => {
                this.loading = false;
            }
        ).catch(
            (error) => this.loading = false
        )
    }


    clickFiltro = () => {
        this.mostrarFiltro = true;
    };

    retornarParaTabela = (predefinicoes) => {

        if (predefinicoes) {
            this.mostrarFiltro = false;
            this.filtrosAvancados = predefinicoes.dadosTabela;
            this.situacaoVisivel = this.extrairSituacoesPredefinicoes(predefinicoes);

            this.aplicaFiltro();
            // this.carregarLista();
        }

    };

    fecharFiltroSemSalvar = () => {
        this.mostrarFiltro = false;
        // this.carregarLista()
    }

    extrairSituacoesPredefinicoes = (arr) => {
        let situacaoVisivel = [];
        if (arr.situacoes)
            arr.situacoes.map(e => { if (e.toLowerCase() !== "todos") situacaoVisivel.push(e) });
        return situacaoVisivel;
    };

    aplicaFiltro() {
        if (!this.situacaoBerco) {

            if (this.situacaoVisivel.length > 0) {
                this.filtroSelecionado["situacoes"] = this.situacaoVisivel.join(',');
            } else {
                delete this.filtroSelecionado["situacoes"];
            }
        }

        if (this.filtrosAvancados) {
            let todasColunas = this.todasColunas;
            this.colunas = todasColunas.filter((item) => {
                return this.filtrosAvancados.indexOf(item.id) > -1;
            });
        }
    }

    getLista() {
        return this.programacaoLista;
    }

    getListaCopia() {
        //Para usar as datas como eu quero em ExportarExcelProgramacaoNavios eu preciso de uma cópia do array de programação
        //Para ter um objeto que não seja uma referência ao observable da lista eu tenho que usar toJS para converter a lista
        return toJS(this.programacaoLista)
    }

    setDataInicio = (value) => {
        this.dataInicial = value;
    };

    setDataFim = (value) => {
        this.dataFinal = value;
    };

    setDataInicioTemp = (value) => {
        this.dataInicialTemp = value;
    };

    setDataFimTemp = (value) => {
        this.dataFinalTemp = value;
    };


    alternarDataSeletor = () => {
        this.seletorPeriodo = !this.seletorPeriodo;
    };

    alternarSituacaoBerco = () => {
        this.situacaoBerco = !this.situacaoBerco;
        this.loading = true;

        if (this.situacaoBerco) {
            this.filtroSelecionadoTemp = this.filtroSelecionado;
            this.filtroSelecionado = [];
            if (this.pesquisaViagem)
                this.filtroSelecionado["Viagem"] = this.pesquisaViagem;
            this.filtroSelecionado["situacoes"] = this.filtrosBerco.join(',');
            this.filtroSelecionado["isBerth"] = "true"
            
        } else {
            this.filtroSelecionadoTemp["Viagem"] = this.pesquisaViagem;
            this.filtroSelecionado = this.filtroSelecionadoTemp;
        }
        this.carregarLista();
    }

    clickPopUpMov = (e, column, columnIndex, row, rowIndex) => {
        const clicked = document.getElementById(`movs_${row.Viagem}`)
        this.popX = clicked.getBoundingClientRect().x
        this.popY = clicked.getBoundingClientRect().y + window.scrollY
        this.movsBox = true
        this.movsData = {
            Viagem: formatNullableValue(row.Viagem),
            Movs: formatNullableValue(row.Movs),
            Carga: formatNullableValue(row.Load),
            Descarga: formatNullableValue(row.Discharge),
            Remocao: formatNullableValue(row.Remocao),
            cargaGeral: formatNullableValue(row.VolumeCg)
        }
    }

    onClickPopUpMovCard(row) {
        this.movsBox = true
        this.movsData = {
            Movs: formatNullableValue(row.Movs),
            Carga: formatNullableValue(row.Load),
            Descarga: formatNullableValue(row.Discharge),
            Remocao: formatNullableValue(row.Remocao),
            cargaGeral: formatNullableValue(row.VolumeCg)
        }
    }

    sairMovsBox = () => {
        this.movsBox = false
    }

    loadFirstTurn = () => {
        this.setItemTabela(this.listaTabela.slice(0, this.toShow));
        this.turnTabela = 1;

        if (this.itemsTabela.length >= this.listaTabela.length) {
            this.hasMoreTabela = false;
        } else {
            this.hasMoreTabela = true
        }
    }

    loadNextTurn() {
        this.setItemTabela(this.listaTabela.slice(this.turnTabela * this.toShow, (this.turnTabela + 1) * this.toShow), true);
        this.turnTabela = this.turnTabela + 1;

        if (this.itemsTabela.length >= this.listaTabela.length) {
            this.hasMoreTabela = false;
        }
    }

    mudarPeriodo() {
        this.setItemTabela(false);
        this.carregarListaEsperando().then(response => {
            this.listaTabela = this.getLista();
            this.loadFirstTurn();
            this.setNoDataTabela(this.tableMessage);
        });
        this.setAtualizaTabela(false);
    }

    alternarSituacaoBercoTabela() {
        this.setItemTabela(false);
        this.setNoDataTabela(<LoadingImage />);
        this.alternarSituacaoBerco();
        this.carregarListaEsperando().then(response => {
            this.listaTabela = this.getLista();
            this.loadFirstTurn();
        }).catch(error => { console.log(error) });
    }

    setItemTabela = (valor, concat = false) => {
        if (concat)
            this.itemsTabela = this.itemsTabela.concat(valor);
        else {
            if (!valor)
                this.itemsTabela = [];
            else
                this.itemsTabela = valor;
        }
    }

    setNoDataTabela = (valor) => {
        this.noDataTabela = valor;
    }

    setAtualizaTabela = (bool) => {
        this.atualizaTabela = bool;
    }

}


// WEBPACK FOOTER //
// ./src/modules/programacao/stores/ProgramacaoNaviosStore.js